import { create } from 'zustand';
import client from '../api/client';

const useUserStore = create((set, get) => ({
  users: [],

  fetchUsers: async () => {
    const { data } = await client.get('/users/');
    set({ users: data });
  },

  assignRole: async (userId, roleName) => {
    const { data } = await client.post('/users/assign-role', {
      user_id: userId,
      role_name: roleName,
    });
    set({ users: get().users.map((u) => (u.id === userId ? data : u)) });
  },

  removeRole: async (userId, roleName) => {
    const { data } = await client.delete('/users/remove-role', {
      data: { user_id: userId, role_name: roleName },
    });
    set({ users: get().users.map((u) => (u.id === userId ? data : u)) });
  },

  deactivateUser: async (userId) => {
    const { data } = await client.patch(`/users/${userId}/deactivate`);
    set({ users: get().users.map((u) => (u.id === userId ? data : u)) });
  },

  resetPassword: async (userId, newPassword) => {
    await client.post(`/users/${userId}/reset-password`, { new_password: newPassword });
  },

  changePassword: async (currentPassword, newPassword) => {
    await client.post('/users/me/change-password', {
      current_password: currentPassword,
      new_password: newPassword,
    });
  },
}));

export default useUserStore;
